import { render } from "./homeEvent.vue?vue&type=template&id=028161a0"
import script from "./homeEvent.vue?vue&type=script&lang=js"
export * from "./homeEvent.vue?vue&type=script&lang=js"

import "./homeEvent.vue?vue&type=style&index=0&id=028161a0&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__